import ProductSportPulse from "./ProductSportPulse.component";

export default ProductSportPulse;
